import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { module, permission } from 'src/app/shared/models/userPermissions';
import { UserPermissionsService } from 'src/app/shared/services/user-permissions.service';
import { searchOrganization } from 'src/app/shared/models/organizations';
import { OrganizationsService } from 'src/app/shared/services/organizations.service';

@Component({
  selector: 'app-edit-permissions',
  templateUrl: './edit-permissions.component.html',
  styleUrls: ['./edit-permissions.component.scss']
})
export class EditPermissionsComponent implements OnInit {
  userName: string[] = [];
  isLoading: boolean = false;
  permissionsByType: any = [];
  selectedPermissionIds: string[] = [];
  overallSelect: boolean = false;
  outlineUserName: boolean;
  atleastOnePermission: boolean = false;
  orgList: searchOrganization[] = [];
  organizationId: number | '' = '';
  hideSubmitBtn: boolean = false;
  outlineOrg: boolean = false;
  selectedDefaultPermission: string = "";
  permissionsForLabUsers: any[] = [
    {label: 'Default Learner Permission', value: 'Learner'},
    {label: 'Default Instructor Permission', value: 'Instructor'}
  ];
  defaultPermission: any[] = [];

  constructor(
    private userPermissionsService: UserPermissionsService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private toasterService: ToastrService,
    private orgService: OrganizationsService,
  ) { }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((params: any) => {
      this.userName.push(params.userid);
      this.organizationId = params.organizationid;
      this.searchOrganizations();
    })
    this.getPermissionNames();
    const permissionType = sessionStorage.getItem('permissionType');
    if(permissionType == "Learner" || permissionType == "Instructor"){
      this.selectedDefaultPermission = sessionStorage.getItem('permissionType');
    }else {
      this.selectedDefaultPermission = "";
    }
  }

  async getPermissionNames() {
    this.isLoading = true;
    try {
      const payload = {
        userId: this.userName,
        organizationId: this.organizationId,
        isUpdate: true
      }
      const result: any = await this.userPermissionsService.permissionNames(payload).toPromise();
      if (result.success) {
        const permissions = result.permissions[0].result.permissions;
        this.permissionsByType = Object.keys(permissions).map((key) => {
          return {
            type: key,
            permissions: permissions[key]
          };
        });
        this.isLoading = false;
      }
    }
    catch (err: any) {
      console.log(err);
      this.hideSubmitBtn = true;
      this.toasterService.error(err.error.message);
      this.isLoading = false;
    }
  }

  onFocus() {
    this.outlineUserName = false;
  }

  toggleSelectAll(module: module, event: any) {
    this.selectedDefaultPermission = "";
    const isChecked = event.target.checked;
    module.permissions.forEach((permission: permission) => {
      permission.hasPermission = isChecked;
    });
    this.updateOverallSelect();
  }

  changeStatus(module: module) {
    const allChecked = module.permissions.every((permission: permission) => permission.hasPermission);
    this.updateOverallSelect();
    return allChecked;
  }

  toggleOverallSelect(event: any) {
    this.selectedDefaultPermission = "";
    const isChecked = event.target.checked;
    this.permissionsByType.forEach((module: module) => {
      module.permissions.forEach((permission: permission) => {
        permission.hasPermission = isChecked;
      });
    });
  }

  updateOverallSelect() {
    this.overallSelect = this.permissionsByType.every((module: module) =>
      module.permissions.every((permission: permission) => permission.hasPermission)
    );
  }


  async onSubmit() {

    if (!this.userName) {
      this.toasterService.error("Username is required");
      this.outlineUserName = true;
      return;
    }

    if (this.organizationId === "") {
      this.outlineOrg = true;
      return;
    }
    this.selectedPermissionIds = [];
    this.permissionsByType.forEach((module: module) => {
      module.permissions.forEach((permission: permission) => {
        if (permission.hasPermission) {
          this.selectedPermissionIds.push(permission.permissionId);
        }
      });
    });

    try {
      this.isLoading = true;
      const payload = {
        users: this.userName,
        permissions: this.selectedPermissionIds,
        organizationId: this.organizationId,
        permissionType: this.selectedDefaultPermission
      }
      const result: any = await this.userPermissionsService.updateUserPermissions(payload).toPromise();
      this.isLoading = false;
      this.toasterService.success(`permissions updated for ${this.userName}`);
      this.router.navigateByUrl('/admin/user-permissions')
    }
    catch (err: any) {
      console.log(err);
      this.toasterService.error(err.error.message);
      this.isLoading = false;
    }
  }

  onOrgFocus() {
    this.outlineOrg = false;
  }

  async searchOrganizations() {
    try {
      this.isLoading = true;
      const payload: searchOrganization = {
        isActive: true
      }
      const result: any = await this.orgService.search(payload).toPromise();
      this.isLoading = false;
      if (result && result.organizations.length > 0) {
        this.orgList = result.organizations;
      }
    } catch (e: any) {
      console.log(e);
      if (e.status == 403) {
        this.toasterService.error(e.error.message)
      }
    }
  }

  onChange(event: any) {
    if (event.target.value !== "") {
      this.organizationId = Number(event.target.value);
    } else {
      this.organizationId = '';
    }
  }

  onCancel() {
    this.router.navigateByUrl('/admin/user-permissions')
  }

  async handleDefaultPermission(event: any) {
    sessionStorage.removeItem('permissionType');
    this.isLoading = true;
    this.selectedDefaultPermission = event.target.value;
    if (event.target.value == "Learner") {
      const learnerPermission: any = await this.userPermissionsService.getDefaultLearnerPermission().toPromise();
      if(learnerPermission.success){
        this.defaultPermission = learnerPermission.data;
        this.autoCheckPermissions();
      }
    } else if (event.target.value == "Instructor") {
      const instructorPermission: any = await this.userPermissionsService.getDefaultInstructorPermission().toPromise();
      if(instructorPermission.success){
        this.defaultPermission = instructorPermission.data;
        this.autoCheckPermissions();
      }
    } else {
      this.defaultPermission = [];
      this.getPermissionNames();
    }
  }
  
  autoCheckPermissions() {
    const defaultPermissionIds = this.defaultPermission.map((dp: any) => dp.permissionId);
    this.permissionsByType.forEach((module: any) => {
      module.permissions.forEach((permission: any) => {
        if (defaultPermissionIds.includes(permission.permissionId)) {
          permission.hasPermission = true;
        }else {
          permission.hasPermission = false;
        }
      });
    });
    this.updateOverallSelect();
    this.isLoading = false;
  }

}
